export const movies = [
  {
    id: "1",
    title: "烈火之心",
    type: "电影",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20passionate%20romance%20drama%2C%20a%20couple%20silhouetted%20against%20burning%20crimson%20sunset%20and%20glowing%20embers%2C%20deep%20red%20and%20warm%20gold%20tones%2C%20dramatic%20moody%20lighting%2C%20elegant%20film%20grain%2C%20high%20contrast%2C%20artistic%20editorial%20style&width=600&height=900&seq=pv-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20scene%20of%20a%20passionate%20romantic%20drama%20film%2C%20two%20figures%20with%20wind%20blown%20hair%20facing%20a%20blazing%20red%20sunset%20over%20an%20open%20field%2C%20deep%20crimson%20and%20amber%20color%20palette%2C%20dramatic%20backlight%2C%20atmospheric%20haze%2C%20moody%20premium%20cinematic%20composition&width=1600&height=900&seq=pv-back-01&orientation=landscape",
    year: 2026,
    region: "中国大陆",
    genres: ["爱情", "剧情"],
    director: "陈望舒",
    cast: ["林述", "苏晚棠", "温以宁"],
    duration: "128 分钟",
    rating: 8.6,
    popularity: 9860,
    specialId: "s6",
    tags: ["热播", "高分", "催泪"],
    synopsis:
      "一场意外让野心勃勃的建筑师闻野与倔强的花艺师沈栖在旧城改造的风波中相遇。两人从针锋相对的对手，到并肩守护一条即将消失的老街，在理想与现实的夹缝里，点燃了一段炙热而克制的爱情。当火焰熄灭，留下的是灰烬，还是重新生长的春天？",
    reviews: [
      { user: "夜航船", score: 9, text: "把爱情的灼热拍得很有层次，闻野和沈栖那场雨戏我看哭了。" },
      { user: "胶片捕手", score: 8, text: "配色太绝了，红与金的碰撞，非常符合激情主题的调性。" },
      { user: "周末看片", score: 9, text: "不是简单的甜，是成年人的拉扯和成全，很有共鸣。" },
    ],
  },
  {
    id: "2",
    title: "暗夜玫瑰",
    type: "电视剧",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20crime%20thriller%20poster%20featuring%20a%20mysterious%20woman%20in%20a%20red%20dress%20standing%20in%20a%20rainy%20neon%20alley%2C%20a%20single%20deep%20red%20rose%20in%20focus%2C%20dark%20cinematic%20tones%20with%20crimson%20accents%2C%20suspenseful%20atmosphere%2C%20elegant%20noir%20style&width=600&height=900&seq=pv-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20noir%20cityscape%20at%20night%20washed%20in%20rain%2C%20warm%20red%20and%20amber%20neon%20reflections%20on%20wet%20asphalt%2C%20a%20lone%20elegant%20figure%20in%20the%20distance%2C%20deep%20shadows%2C%20moody%20crime%20drama%20atmosphere%2C%20premium%20film%20look&width=1600&height=900&seq=pv-back-02&orientation=landscape",
    year: 2025,
    region: "中国香港",
    genres: ["悬疑", "犯罪", "爱情"],
    director: "麦兆辉",
    cast: ["顾承川", "沈书瑶", "江砚"],
    duration: "全 36 集",
    rating: 8.9,
    popularity: 9420,
    specialId: "s4",
    tags: ["热播", "悬疑", "口碑"],
    synopsis:
      "连环案件背后，一支带血的玫瑰成为唯一线索。刑警程砚在追查真相时，发现嫌疑人竟是自己年少时挚爱的女人。爱与正义、真相与谎言的边界在暗夜里逐渐模糊，她到底是凶手，还是被利用的棋子？",
    reviews: [
      { user: "推理控", score: 9, text: "节奏紧凑，每集结尾都让人想立刻点下一集。" },
      { user: "港剧迷", score: 9, text: "氛围感拉满，雨夜霓虹就是港式悬疑的灵魂。" },
      { user: "深夜追剧", score: 8, text: "感情线不拖沓，和悬疑线配合得很好。" },
    ],
  },
  {
    id: "3",
    title: "都市迷情",
    type: "电视剧",
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20series%20poster%20of%20two%20elegant%20people%20in%20business%20attire%20almost%20touching%20in%20a%20glassy%20skyscraper%20at%20dusk%2C%20warm%20amber%20and%20muted%20red%20lighting%2C%20sophisticated%20city%20mood%2C%20refined%20editorial%20poster%20style&width=600&height=900&seq=pv-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Elegant%20modern%20city%20skyline%20at%20golden%20dusk%20viewed%20through%20a%20floor%20to%20ceiling%20window%2C%20warm%20amber%20glow%20with%20subtle%20deep%20red%20highlights%2C%20sophisticated%20urban%20romance%20drama%20atmosphere%2C%20clean%20premium%20cinematic%20look&width=1600&height=900&seq=pv-back-03&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["都市", "爱情", "剧情"],
    director: "李牧川",
    cast: ["陆时衍", "苏晚棠", "韩行舟"],
    duration: "全 40 集",
    rating: 8.3,
    popularity: 8710,
    specialId: "s3",
    tags: ["都市", "职场", "高热"],
    synopsis:
      "投资总监顾行简以冷静著称，直到遇见初入职场却锋芒毕露的实习生江晚。一场商业并购案让两人被迫合作，办公室的明争暗斗之外，是两颗骄傲的心在深夜加班的灯光里慢慢靠近。城市很大，迷路的其实是心。",
    reviews: [
      { user: "打工魂", score: 8, text: "职场细节写得真实，恋爱部分又不狗血，很上头。" },
      { user: "柠檬汽水", score: 9, text: "双强设定太香了，台词都很有味道。" },
      { user: "追剧阿姨", score: 8, text: "服化道精致，都市感很强。" },
    ],
  },
  {
    id: "4",
    title: "炽爱迷宫",
    type: "电影",
    poster:
      "https://readdy.ai/api/search-image?query=Arthouse%20romantic%20thriller%20poster%20with%20mirrored%20silhouettes%20of%20a%20couple%20inside%20an%20endless%20elegant%20maze%20of%20warm%20red%20walls%2C%20amber%20light%20spilling%20through%20openings%2C%20dreamlike%20surreal%20mood%2C%20editorial%20cinematic%20design&width=600&height=900&seq=pv-poster-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Surreal%20cinematic%20corridor%20maze%20with%20warm%20deep%20red%20walls%20and%20amber%20lighting%20streaming%20through%20narrow%20openings%2C%20two%20distant%20figures%20meeting%20at%20a%20turn%2C%20dreamlike%20romantic%20thriller%20atmosphere%2C%20artistic%20premium%20film%20composition&width=1600&height=900&seq=pv-back-04&orientation=landscape",
    year: 2025,
    region: "韩国",
    genres: ["爱情", "悬疑"],
    director: "朴成勋",
    cast: ["白鹿鸣", "林述", "沈书瑶"],
    duration: "116 分钟",
    rating: 8.7,
    popularity: 8230,
    specialId: "s2",
    tags: ["烧脑", "氛围", "高分"],
    synopsis:
      "每到午夜，设计师秀雅都会在一座不断变换的迷宫走廊里遇见同一个陌生男人。白天，他是公司里最冷漠的上司；夜里，他却记得所有她遗忘的事。当梦境与现实的边界崩塌，她必须选择相信哪一段才是真正的相爱。",
    reviews: [
      { user: "梦境考古", score: 9, text: "结构很妙，看完忍不住回想每一个细节。" },
      { user: "镜头语言", score: 9, text: "美术和光影太美了，红墙走廊记忆深刻。" },
      { user: "艺术片爱好者", score: 8, text: "爱情包裹着悬疑，情绪很有层次。" },
    ],
  },
  {
    id: "5",
    title: "血色浪漫",
    type: "电影",
    poster:
      "https://readdy.ai/api/search-image?query=Nostalgic%20period%20romance%20film%20poster%20of%20a%20young%20couple%20in%20vintage%201990s%20clothing%20cycling%20past%20old%20courtyard%20walls%20at%20red%20sunset%2C%20rich%20crimson%20and%20faded%20gold%20tones%2C%20film%20grain%20texture%2C%20warm%20bittersweet%20nostalgic%20mood&width=600&height=900&seq=pv-poster-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20city%20street%20from%20the%201990s%20at%20red%20sunset%2C%20vintage%20bicycles%20and%20tall%20trees%2C%20a%20young%20couple%20walking%20away%20hand%20in%20hand%2C%20rich%20crimson%20and%20amber%20color%20grading%2C%20soft%20film%20grain%2C%20bittersweet%20period%20drama%20mood&width=1600&height=900&seq=pv-back-05&orientation=landscape",
    year: 2023,
    region: "中国大陆",
    genres: ["年代", "爱情", "剧情"],
    director: "黄建明",
    cast: ["江砚", "叶知秋", "林述"],
    duration: "134 分钟",
    rating: 8.8,
    popularity: 7980,
    specialId: "s5",
    tags: ["年代", "经典", "催泪"],
    synopsis:
      "上世纪九十年代，钢厂子弟赵山河与厂医之女苏念在轰鸣的车间与昏黄的路灯下相爱。时代洪流裹挟着理想与离别，他们用最滚烫的青春对抗命运。多年后重逢，那条老街还在，只是再没有人骑着单车等她下夜班。",
    reviews: [
      { user: "老电影", score: 9, text: "年代感太真实了，像翻开了父母的相册。" },
      { user: "怀旧派", score: 9, text: "结局哭到不行，克制却后劲十足。" },
      { user: "影评人老周", score: 8, text: "群像塑造到位，是近几年少见的年代爱情片。" },
    ],
  },
  {
    id: "6",
    title: "燃情岁月",
    type: "电视剧",
    poster:
      "https://readdy.ai/api/search-image?query=Retro%20era%20drama%20series%20poster%20featuring%20a%20strong%20woman%20and%20man%20standing%20back%20to%20back%20in%20vintage%20factory%20overalls%20against%20a%20warm%20rust%20and%20crimson%20industrial%20backdrop%2C%20grainy%20film%20texture%2C%20warm%20aging%20nostalgic%20tone&width=600&height=900&seq=pv-poster-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Nostalgic%20industrial%20factory%20district%20at%20warm%20golden%20hour%2C%20tall%20chimneys%20and%20steam%2C%20vintage%20era%20atmosphere%2C%20rich%20rust%20brown%20and%20crimson%20grading%2C%20soft%20film%20grain%2C%20epic%20period%20drama%20mood&width=1600&height=900&seq=pv-back-06&orientation=landscape",
    year: 2022,
    region: "中国大陆",
    genres: ["年代", "爱情"],
    director: "周和平",
    cast: ["沈书瑶", "陆时衍", "韩行舟"],
    duration: "全 45 集",
    rating: 8.5,
    popularity: 7640,
    specialId: "s5",
    tags: ["年代", "群像", "口碑"],
    synopsis:
      "改革开放的浪潮里，一群年轻人从国营大厂走向市场大潮。技术员韩雷与会计林芳在一次次抉择中相互扶持，也在诱惑与背叛中学会成长。岁月滚烫，唯有并肩走过的人，才懂什么叫燃情。",
    reviews: [
      { user: "岁月如歌", score: 9, text: "把一代人的奋斗和爱情都写进去了，很有力量。" },
      { user: "追剧笔记", score: 8, text: "群像戏很稳，每个人物都立得住。" },
      { user: "妈妈也追剧", score: 8, text: "我妈看得比我还入迷，年代氛围绝了。" },
    ],
  },
  {
    id: "7",
    title: "深海之吻",
    type: "电影",
    poster:
      "https://readdy.ai/api/search-image?query=Poetic%20romance%20film%20poster%20of%20a%20couple%20embracing%20under%20deep%20blue%20water%20with%20warm%20amber%20sunlight%20rays%20piercing%20through%2C%20bubbles%20and%20flowing%20fabric%2C%20serene%20dreamy%20cinematic%20mood%2C%20elegant%20artistic%20composition&width=600&height=900&seq=pv-poster-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Serene%20underwater%20seascape%20with%20golden%20sunlight%20beams%20piercing%20deep%20teal%20water%2C%20schools%20of%20small%20fish%2C%20a%20soft%20romantic%20dreamy%20atmosphere%2C%20warm%20highlights%20against%20cool%20depths%2C%20poetic%20cinematic%20look&width=1600&height=900&seq=pv-back-07&orientation=landscape",
    year: 2024,
    region: "日本",
    genres: ["爱情", "剧情"],
    director: "森下真",
    cast: ["温以宁", "白鹿鸣"],
    duration: "112 分钟",
    rating: 8.4,
    popularity: 7210,
    specialId: "s6",
    tags: ["治愈", "唯美", "文艺"],
    synopsis:
      "失去听力的潜水员凛，在冲绳的海底遇见了同样带着伤痛的失恋摄影师夏川。两人用纸笔和手语交换彼此的秘密，在没有声音的世界里，听见了最清晰的心跳。有些爱情，像深海一样安静，却足以托起整个人生。",
    reviews: [
      { user: "海盐味", score: 9, text: "画面美到窒息，安静的浪漫反而更有力量。" },
      { user: "日影迷", score: 8, text: "两位主演的表演细腻，手语戏份特别动人。" },
      { user: "治愈系", score: 8, text: "看完很平静，很适合深夜一个人看。" },
    ],
  },
  {
    id: "8",
    title: "霓虹之下",
    type: "网络剧",
    poster:
      "https://readdy.ai/api/search-image?query=Youth%20urban%20web%20series%20poster%20of%20a%20stylish%20young%20couple%20dancing%20on%20a%20rooftop%20surrounded%20by%20warm%20amber%20and%20crimson%20neon%20signs%20at%20night%2C%20vibrant%20energetic%20mood%2C%20modern%20street%20style%20aesthetic&width=600&height=900&seq=pv-poster-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Vibrant%20night%20city%20rooftop%20scene%20glowing%20with%20warm%20amber%20and%20red%20neon%20signs%2C%20distant%20skyline%20bokeh%2C%20energetic%20youthful%20urban%20nightlife%20atmosphere%2C%20stylish%20modern%20cinematic%20grade&width=1600&height=900&seq=pv-back-08&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["都市", "爱情", "青春"],
    director: "郑小雨",
    cast: ["韩行舟", "白鹿鸣", "苏晚棠"],
    duration: "全 24 集",
    rating: 8.1,
    popularity: 6890,
    specialId: "s2",
    tags: ["青春", "轻快", "高甜"],
    synopsis:
      "白天是循规蹈矩的插画师，晚上是地下舞团的灵魂舞者。当乖乖女季南遇上神秘的乐队主唱江野，两条看似平行的青春轨迹在霓虹灯下交错。理想、热爱与心动，都在这座不眠的城市里野蛮生长。",
    reviews: [
      { user: "夜猫子", score: 8, text: "青春感十足，配乐一响就想跟着摇摆。" },
      { user: "甜剧收割机", score: 9, text: "男女主化学反应太好了，磕到了。" },
      { user: "城市漫游", score: 8, text: "拍出了都市夜晚的浪漫，很有代入感。" },
    ],
  },
  {
    id: "9",
    title: "罪爱双生",
    type: "电视剧",
    poster:
      "https://readdy.ai/api/search-image?query=Psychological%20crime%20series%20poster%20of%20identical%20twin%20sisters%20one%20in%20white%20one%20in%20deep%20red%2C%20half%20lit%20faces%2C%20cracked%20mirror%20between%20them%2C%20tense%20dark%20crimson%20and%20charcoal%20palette%2C%20suspenseful%20dramatic%20mood&width=600&height=900&seq=pv-poster-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dark%20tense%20interrogation%20room%20with%20a%20single%20hanging%20lamp%2C%20deep%20crimson%20and%20charcoal%20shadows%2C%20an%20empty%20chair%20and%20scattered%20files%2C%20brooding%20psychological%20thriller%20atmosphere%2C%20cinematic%20moody%20lighting&width=1600&height=900&seq=pv-back-09&orientation=landscape",
    year: 2026,
    region: "韩国",
    genres: ["悬疑", "犯罪", "爱情"],
    director: "金泰宇",
    cast: ["沈书瑶", "顾承川", "温以宁"],
    duration: "全 32 集",
    rating: 8.6,
    popularity: 6620,
    specialId: "s4",
    tags: ["悬疑", "烧脑", "双生"],
    synopsis:
      "检察官徐真理调查一桩离奇命案，所有证据都指向她失散多年的双胞胎姐姐。真相被一层层剥开时，她发现两人的命运早已在出生那天就被紧紧绑在一起。罪与爱，究竟谁在替谁赎罪？",
    reviews: [
      { user: "悬疑雷达", score: 9, text: "反转不断，全程不敢快进。" },
      { user: "心理迷", score: 9, text: "双生设定用得很高级，情绪张力很强。" },
      { user: "夜读剧本", score: 8, text: "女主一人分饰两角，演技炸裂。" },
    ],
  },
  {
    id: "10",
    title: "南风知我意",
    type: "电视剧",
    poster:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20romance%20poster%20of%20a%20noble%20lady%20in%20flowing%20red%20robes%20and%20a%20young%20scholar%2C%20falling%20petals%2C%20traditional%20pavilion%20at%20dusk%2C%20rich%20crimson%20and%20gold%20tones%2C%20elegant%20poetic%20cinematic%20style&width=600&height=900&seq=pv-poster-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20pavilion%20by%20a%20misty%20lake%20at%20sunset%2C%20cherry%20blossoms%20drifting%2C%20warm%20crimson%20and%20gilded%20gold%20color%20palette%2C%20poetic%20elegant%20period%20drama%20atmosphere%2C%20premium%20cinematic%20composition&width=1600&height=900&seq=pv-back-10&orientation=landscape",
    year: 2023,
    region: "中国大陆",
    genres: ["古装", "爱情"],
    director: "顾长风",
    cast: ["叶知秋", "江砚", "林述"],
    duration: "全 38 集",
    rating: 8.2,
    popularity: 6410,
    specialId: "s1",
    tags: ["古装", "唯美", "虐恋"],
    synopsis:
      "丞相之女沈知意奉旨嫁入将军府，冷面将军裴琰却对她处处设防。边关烽火、朝堂暗涌，两人从相敬如宾到生死相托。南风起时，她终于读懂他藏在铠甲下的温柔。这一世的倾心，换来的是相守，还是别离？",
    reviews: [
      { user: "古偶党", score: 8, text: "服化道精美，红衣造型惊艳。" },
      { user: "追剧少女", score: 9, text: "虐中带甜，节奏把控得很好。" },
      { user: "古风控", score: 8, text: "画面像一幅水墨画，很养眼。" },
    ],
  },
  {
    id: "11",
    title: "逆光之恋",
    type: "网络剧",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20youth%20web%20series%20poster%20of%20a%20young%20couple%20silhouetted%20against%20warm%20golden%20sunlight%20streaming%20through%20school%20windows%2C%20soft%20amber%20and%20muted%20red%20tones%2C%20nostalgic%20first%20love%20mood%2C%20delicate%20dreamy%20aesthetic&width=600&height=900&seq=pv-poster-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Sunlit%20school%20corridor%20in%20late%20afternoon%20with%20golden%20light%20streaming%20through%20tall%20windows%2C%20floating%20dust%20motes%2C%20warm%20amber%20and%20soft%20red%20tones%2C%20nostalgic%20youthful%20first%20love%20atmosphere%2C%20dreamy%20cinematic%20look&width=1600&height=900&seq=pv-back-11&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["青春", "爱情"],
    director: "许清和",
    cast: ["韩行舟", "温以宁"],
    duration: "全 20 集",
    rating: 8.0,
    popularity: 6120,
    specialId: "s6",
    tags: ["青春", "治愈", "初恋"],
    synopsis:
      "转学生夏栀带着一身秘密来到新学校，遇到了总在逆光里等她的少年程屿。一个不敢被看见，一个习惯替别人遮风。当青春的迷雾散去，他们才明白，真正让人成长的，是那个愿意陪你走向光的人。",
    reviews: [
      { user: "青春回忆录", score: 8, text: "很纯粹的心动，看的时候一直在笑。" },
      { user: "校园控", score: 8, text: "光影拍得好美，满满的夏日感。" },
      { user: "小确幸", score: 9, text: "没有狗血，只有温柔，很治愈。" },
    ],
  },
  {
    id: "12",
    title: "长夜燃灯",
    type: "短片",
    poster:
      "https://readdy.ai/api/search-image?query=Atmospheric%20short%20film%20poster%20of%20a%20lone%20figure%20holding%20a%20warm%20lantern%20in%20a%20vast%20dark%20empty%20street%20at%20midnight%2C%20single%20crimson%20light%20source%2C%20deep%20shadows%2C%20intimate%20mysterious%20cinematic%20mood&width=600&height=900&seq=pv-poster-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Empty%20misty%20street%20at%20midnight%20illuminated%20by%20warm%20lantern%20light%2C%20deep%20crimson%20glow%20reflected%20on%20wet%20ground%2C%20faint%20shadows%2C%20quiet%20melancholic%20cinematic%20atmosphere%2C%20intimate%20short%20film%20mood&width=1600&height=900&seq=pv-back-12&orientation=landscape",
    year: 2025,
    region: "美国",
    genres: ["惊悚", "悬疑", "剧情"],
    director: "Ethan Vale",
    cast: ["陆时衍", "顾承川"],
    duration: "42 分钟",
    rating: 8.5,
    popularity: 5870,
    specialId: "s2",
    tags: ["短片", "氛围", "高分"],
    synopsis:
      "一名守夜人在空无一人的老城区巡逻，手里的灯是他唯一的温暖。每当灯熄灭，他就会看见不该看见的东西。长夜漫漫，他究竟在守护城市，还是在守护一个不愿醒来的梦？",
    reviews: [
      { user: "短片计划", score: 9, text: "四十分钟讲了一个很完整的悬念，厉害。" },
      { user: "恐怖片迷", score: 8, text: "不靠吓人，靠氛围，看完后背发凉。" },
      { user: "光影笔记", score: 9, text: "一盏灯的明灭，撑起了全部张力。" },
    ],
  },
];